var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('notification-snack'),_c('v-main',[_c('server-status'),_c('language-select',{on:{"change":_vm.setLang}}),_c('meet-container',[(_vm.isLoading)?_c('loading'):_vm._e(),_c('router-view')],1),_c('help-bubble')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }